import { useCallback } from 'react';

const EVENT_SPECIFIC = 'Event Specific';
const CLICK_EVENT_GENERIC = 'Click Event Generic';
const CLICK_TYPE = 'Click';
const IMPRESSION_TYPE = 'Impression';
const AREA = 'autoshipment';
const useAdobeUtils = () => {
    const trackCartMOVError = useCallback(() => {
        sendAdobeEvent({
            event: EVENT_SPECIFIC,
            interaction: {
                type: IMPRESSION_TYPE,
                name: AREA + ':MOV notification',
            },
        });
    }, []);
    const trackIntervalChanged = (interval) => {
        sendAdobeEvent({
            event: CLICK_EVENT_GENERIC,
            interaction: {
                type: CLICK_TYPE,
                name: AREA + ':change delivery interval',
                details: {
                    area: AREA,
                    identifier: 'change delivery interval',
                    targetLink: '' + interval,
                },
            },
        });
    };
    const trackCartRemoveAutoshipment = useCallback(() => {
        sendAdobeEvent({
            event: CLICK_EVENT_GENERIC,
            interaction: {
                type: CLICK_TYPE,
                name: AREA + ':checkout cart offerbox:remove',
                details: {
                    area: AREA,
                    identifier: "checkout cart offerbox",
                    targetLink: "remove"
                }
            },
        });
    }, []);
    const trackPreviewMOVError = useCallback(() => {
        sendAdobeEvent({
            event: EVENT_SPECIFIC,
            interaction: {
                type: IMPRESSION_TYPE,
                name: AREA + ':MOV error notification',
            },
        });
    }, []);
    const trackPreviewPaymentError = useCallback(() => {
        sendAdobeEvent({
            event: EVENT_SPECIFIC,
            interaction: {
                type: IMPRESSION_TYPE,
                name: AREA + ':Payment Method error notification',
            },
        });
    }, []);
    const trackPreviewCardNotSavedError = useCallback(() => {
        sendAdobeEvent({
            event: EVENT_SPECIFIC,
            interaction: {
                type: IMPRESSION_TYPE,
                name: AREA + ':Credit Card not saved error',
            },
        });
    }, []);
    const trackPreviewGuestError = useCallback(() => {
        sendAdobeEvent({
            event: EVENT_SPECIFIC,
            interaction: {
                type: IMPRESSION_TYPE,
                name: AREA + ':Guest error notification',
            },
        });
    }, []);
    const trackPreviewCorrectOffer = useCallback(() => {
        sendAdobeEvent({
            event: EVENT_SPECIFIC,
            interaction: {
                type: IMPRESSION_TYPE,
                name: AREA + ':No error notification',
            },
        });
    }, []);
    const trackDefaultInterval = useCallback((sid, variant) => {
        try {
            window?._satellite?.setVar?.('SID', sid);
            window?.SendABTestData?.('ope', 'delivery_interval_a_b_test', variant);
        }
        catch (e) {
            console.error(e);
        }
    }, []);
    const sendAdobeEvent = (event) => {
        const evt = new CustomEvent('AboTracking', {
            detail: event,
        });
        window.dispatchEvent(evt);
    };
    return {
        trackCartMOVError,
        trackIntervalChanged,
        trackCartRemoveAutoshipment,
        trackPreviewMOVError,
        trackPreviewPaymentError,
        trackPreviewCardNotSavedError,
        trackPreviewGuestError,
        trackPreviewCorrectOffer,
        trackDefaultInterval,
    };
};

export { useAdobeUtils as default };
//# sourceMappingURL=useAdobe.js.map
